// extracted by mini-css-extract-plugin
export default {"imageContainer":"p2-z","summaryPar":"q2-z","ratingCategories":"r2-z","reviewerInfo":"s2-z","reviewTypes":"t2-z","expanded":"u2-z"};